// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';
import PdbImage from '../../../pdbImage';
import Reserved from '../reserved';

type OwnProps = {|
  url: string,
  alt?: string,
  className: string,
  isReserved?: boolean,
  reservedText?: string,
|};

type Props = OwnProps;

const CarBlockImage = styled<typeof PdbImage, Theme, _>(PdbImage)`
  max-width: 100%;

  ${media.sm(css`
    max-height: 100%;
  `)}
`;

const ImageWrapper = styled<any, Theme>('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
`;

// For the time being the image-width has been set to 350px.
// This component is on the nomination list for a full refactor
// TODO: Fully refactoring the carblock
const Image = ({
  url, alt, className, isReserved, reservedText,
}: Props) => (
  <ImageWrapper className={className}>
    <CarBlockImage
      alt={alt}
      url={url.replace('__width__', '350')}
    />
    {isReserved && (
      <Reserved>
        {reservedText}
      </Reserved>
    )}
  </ImageWrapper>
);

Image.defaultProps = {
  alt: '',
};

export default styled<typeof Image, Theme, _>(Image)`
  text-align: center;
`;
